export interface AutoReplyDraft {
	enabled: boolean;
	fromName: string;
	fromEmail: string;
	bodyHtml: string;
}

export type AutoReplyField = 'fromName' | 'fromEmail';

export interface AutoReplyValidationError {
	field: AutoReplyField;
	message: string;
}

export function validateAutoReply(draft: AutoReplyDraft): AutoReplyValidationError | null {
	if (!draft.enabled) return null;

	if (draft.fromName.trim() === '') {
		return {field: 'fromName', message: 'From name is required'};
	}
	return null;
}

export function autoReplyFieldError(error: AutoReplyValidationError | null, field: AutoReplyField): string | null {
	if (!error || error.field !== field) return null;
	return error.message;
}
